import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavHeaderRoutingModule } from './nav-header-routing.module';
import { NavHeaderComponent } from './nav-header.component';
import { MobileComponent } from './mobile/mobile.component';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalSearchComponent } from '../shared/global-search/global-search.component';

@NgModule({
  exports: [
    NavHeaderComponent,
    GlobalSearchComponent
  ],
  declarations: [
    NavHeaderComponent,
    MobileComponent,
    GlobalSearchComponent
  ],
  imports: [
    CommonModule,
    NavHeaderRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbCollapseModule,
    NgbDropdownModule
  ]
})
export class NavHeaderModule { }
